export const PhoneNumberFormats = {
    american: {
        format: '(###) ###-####',
        length: 10
    },
    israeliHouse: {
        format: '(##) ###-####',
        length: 9,
    },
    israeliCell: {
        format: '(###) ###-####',
        length: 10
    }
};

export const PhoneNumberTypes = {
    American: "US",
    Israeli: "IL",
    Other: "Other"
};

export const TableViews = {
    Standard: 'standard',
    Detailed: 'detailed'
}

export const TableNames = {
    Applications: 'APPLICATIONS',
    Recipients: 'RECIPIENTS',
    References: 'REFERENCES',
    DuplicateRecipients: 'DUPLICATE_RECIPIENTS',
    Campaigns: 'CAMPAIGNS',
    CampaignLists: 'CAMPAIGN_LISTS',
    CampaignListParticipants: 'CAMPAIGN_LIST_PARTICIPANTS',
    CampaignListApplications: 'CAMPAIGN_LIST_APPLICATIONS',
    CampaignDetailsLists: 'CAMPAIGN_DETAILS_LISTS',
    CampaignDetailsIndividuals: 'CAMPAIGN_DETAILS_INDIVIDUALS',
    ExternalCampaignListParticipants: 'EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS',
    Users: 'USERS',
    AccountingTransactions: 'ACCOUNTING_TRANSACTIONS',
    AccountingOutsideTransactions: 'ACCOUNTING_OUTSIDE_TRANSACTIONS',
    ReconciliationPayments: 'RECONCILIATION_PAYMENTS',
    ReconciliationCredits: 'RECONCILIATION_CREDITS',
    ReceivingParticipants: 'RECEIVING_PARTICIPANTS'
};

export const TagTypes = {
    Campaigns: 'Campaigns',
    Funds: 'Funds',
    Approvers: 'Approvers',
    Organizations: 'Organizations'
};

export const TagNames = {
    IndividualTags: 'individualTags',
    OrganizationTags: 'organizationTags',
    IndividualApplicationReasons: 'individualApplicationReasons',
    OrganizationApplicationReasons: 'organizationApplicationReasons',
    Banks: 'banks',
    CardTypes: 'cardTypes',
    CampaignCategories: 'campaignCategories',
    CampaignIndivCategories: 'campaignIndivCategories',
    LocationGroups: 'campaignLocationGroups',
    WithdrawalTypes: 'withdrawalTypes',
    DepositSources: 'depositSources',
    USPersonTitles: 'usPersonTitles',
    IsraelPersonTitles: 'israelPersonTitles',
    USInstitutionTitles: 'usInstitutionTitles',
    IsraelInstitutionTitles: 'israelInstitutionTitles',
};

export const SettingNames = {
    CurrencyConversionRate: 'currencyConversionRate',
    FromEmailAddress: 'fromEmailAddress',
    ReturnAddress: 'returnAddress',
    DefaultUSFund: 'defaultUSFund',
    DefaultILFund: 'defaultIsraelFund',
    Signatures: 'signatures',
    AuthorizeCloudPrint: 'cloudPrint'
};

export const PartialSettings = {
    AllSettings: 'allSettings',
    PaymentSettings: 'paymentSettings',
    RecipientSettings: 'recipientSettings',
    ApplicationSettings: 'applicationSettings',
    CampaignSettings: 'campaignSettings',
    FundSettings: 'fundSettings',
    PrintSettings: 'printSettings',
    OtherSettings: 'otherSettings'
};

export const IncompleteTypes = {
    Recipient: 'Recipient',
    Application: 'Application'
};

export const LanguageTypes = {
    Hebrew: 'iw',
    English: ''
};

export const TransactionTypes = {
    Withdrawal: 'Withdrawal',
    Deposit: 'Deposit'
};

export const MonthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

export const PayeeTypes = {
    Recipient: 'Recipient',
    ThirdParty: 'ThirdParty',
    TrustedPayee: 'TrustedPayee'
};

export const SourceTypes = {
    New: 'new',
    Reference: 'reference'
};


// WEBPACK FOOTER //
// ./src/lib/constants.js